import AvatarWithTextItem from './AvatarWithTextItem';

export default AvatarWithTextItem;
